import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=b274d946&scoped=true"
import script from "./InformationBox.vue?vue&type=script&lang=ts"
export * from "./InformationBox.vue?vue&type=script&lang=ts"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=b274d946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b274d946",
  null
  
)

export default component.exports